// extracted by mini-css-extract-plugin
export default {"container":"NightThemeToggle_container__VpRi+","text":"NightThemeToggle_text__Uo+Ud"};